"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridInfinityProcessor = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const IGTradeUtils_1 = require("../../TradeUtils/IGTradeUtils");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const GridTradingUtils_1 = require("../GridTrading/GridTradingUtils");
exports.GridInfinityProcessor = {
    useUserParams(low, invest, stopLostPrice, takeProfitPrice, investPercent, investAction, profitRatePerGrid, baseAvailable, quoteAvailable, investCoinType, currentPrice, symbol, market, tradeAPI, botType, condition) {
        const profitRatePerGridNum = (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal(profitRatePerGrid).toNumber();
        }, [profitRatePerGrid]);
        const openPrice = condition || currentPrice;
        const [totalBalance, baseBalance, quoteBalance] = (0, react_1.useMemo)(() => {
            const baseB = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(baseAvailable, symbol.amount);
            const quoteB = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, symbol.precision);
            let totalB = quoteB;
            if (investCoinType === "both") {
                const total = new trade_utils_lib_1.SafeDecimal(baseAvailable)
                    .mul(new trade_utils_lib_1.SafeDecimal(openPrice))
                    .add(new trade_utils_lib_1.SafeDecimal(quoteAvailable));
                totalB = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(total, symbol.precision);
            }
            return [totalB, baseB, quoteB];
        }, [
            baseAvailable,
            quoteAvailable,
            symbol.precision,
            openPrice,
            investCoinType,
        ]);
        const [balanceDisplay, balanceDescDisplay] = (0, react_1.useMemo)(() => {
            const totalStr = `= ${totalBalance} ${symbol.quote}`;
            if (investCoinType === "both") {
                const descStr = `(${baseBalance}${symbol.baseDisplay}+${quoteBalance}${symbol.quote})`;
                return [totalStr, descStr];
            }
            else {
                return [totalStr, ""];
            }
        }, [baseBalance, quoteBalance, totalBalance, symbol, investCoinType]);
        const [feeRate, feeRateError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbol, tradeAPI, market, "maker");
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investAction, invest, investPercent, totalBalance, symbol.precision);
        const [minInvest, minLoading, minError] = IGTradeUtils_1.IGTradeUtils.useMinInvest(symbol, low, profitRatePerGridNum, tradeAPI, market);
        const minInvestStr = `${minInvest}`;
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvestStr,
                max: totalBalance,
            };
            if (Number(parseInvest)) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(totalBalance))) {
                    state.state = "large";
                }
                if (Number(minInvestStr)) {
                    if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvestStr))) {
                        state.state = "small";
                    }
                }
            }
            return state;
        }, [minInvestStr, totalBalance, parseInvest, symbol.symbol]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(low)) {
                emptys.push("trade_lower_price");
            }
            if (!Number(profitRatePerGrid)) {
                emptys.push("grid_profit_per_grid");
            }
            if (!Number(parseInvest)) {
                emptys.push("trade_investment");
            }
            return emptys;
        }, [low, profitRatePerGrid, parseInvest]);
        const condition_direction = GridTradingUtils_1.GridTradingUtils.getConditionDirection(condition !== null && condition !== void 0 ? condition : "", String(currentPrice));
        return {
            low,
            investText: parseInvest,
            stopLostPrice,
            takeProfitPrice,
            investPercent: parseInvestPercent,
            profitRatePerGrid,
            minInvest: `${minInvest}`,
            minInvestLoading: minLoading,
            minInvestError: minError,
            currentPrice: currentPrice,
            baseAvaliable: baseBalance,
            quoteAvaliable: quoteBalance,
            totalAvaliable: totalBalance,
            investState,
            investCoinType,
            botType,
            emptyErrors,
            symbol,
            feeRate,
            balanceDisplay,
            balanceDescDisplay,
            condition: condition !== null && condition !== void 0 ? condition : "",
            condition_direction: condition_direction,
        };
    },
    checkLocalError: (params, $st) => {
        if (params.emptyErrors.length > 0) {
            return $st("trade_params_not_fill_enough");
        }
        if (params.investState.state === "small") {
            return $st("trade_error_low_amount", {
                amount: `${params.investState.min} ${params.symbol.quote}`,
            });
        }
        else if (params.investState.state === "large") {
            return $st("not_enough_balance");
        }
        const openPrice = new trade_utils_lib_1.SafeDecimal(params.condition || params.currentPrice);
        GridTradingUtils_1.GridTradingUtils.getConditionDirectionWithFormatterError(params.condition, String(params.currentPrice), $st);
        const takeProfitD = new trade_utils_lib_1.SafeDecimal(params.takeProfitPrice);
        const stopLostD = new trade_utils_lib_1.SafeDecimal(params.stopLostPrice);
        if (params.takeProfitPrice) {
            if (takeProfitD.lessThanOrEqualTo(openPrice)) {
                return $st("grid_bullish_take_profit_error_current_price");
            }
        }
        if (params.stopLostPrice) {
            if (stopLostD.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(params.low))) {
                return $st("grid_bullish_stop_loss_error");
            }
            if (stopLostD.greaterThanOrEqualTo(openPrice)) {
                return $st("grid_bullish_stop_loss_error_current_price");
            }
        }
        const rateD = new trade_utils_lib_1.SafeDecimal(params.profitRatePerGrid);
        const feeRateD = new trade_utils_lib_1.SafeDecimal(params.feeRate);
        if (params.profitRatePerGrid &&
            (rateD.greaterThan(0.1) || rateD.lessThan(feeRateD.mul(2)))) {
            const min = trade_utils_lib_1.NumberCommonUtils.toPercent(feeRateD.mul(2).mul(100), false);
            return $st("ig_trading_rate_range_error", { min: min });
        }
        return "";
    },
};
